import { ACTUALITY_EMPLOYEE_SHIFT_MAPPING_SCHEMA } from '@warebee/shared/import-converter';
import { InferResult, QueryCreator, sql } from 'kysely';
import _ from 'lodash';
import { DatasetDatabase } from '../../datasetQueryBuilder';
import { DocumentContextQueryBuilderParams } from '../../datasetQueryBuilder.types';

export type ActualityEmployeeShiftDataRows = InferResult<
  ReturnType<typeof getActualityEmployeeShiftQueryBuilder>
>;
export type ActualityEmployeeShiftDataRow =
  ActualityEmployeeShiftDataRows[number];
export type ActualityEmployeeShiftDataColumn =
  keyof ActualityEmployeeShiftDataRow;

export function getActualityEmployeeShiftQueryBuilder<
  T extends DatasetDatabase,
>(
  documentContext: DocumentContextQueryBuilderParams,
  db: QueryCreator<T> /*QueryCreator<DatasetDatabase> */,
) {
  const from = documentContext?.from;
  const to = documentContext?.to;
  let qb = db
    .selectFrom('___actuality_employee_shift___')
    .where('datasetObjectId', '=', documentContext.documentId as any)
    .select(
      _(ACTUALITY_EMPLOYEE_SHIFT_MAPPING_SCHEMA.fields)
        .map(f => f.name)
        .value(),
    )
    .$if(!_.isNil(from), db =>
      db.where('shiftEnd', '>=', sql<Date>`cast( ${from} as timestamp)` as any),
    )

    .$if(!_.isNil(to), db =>
      db.where('shiftStart', '<=', sql<Date>`cast( ${to} as timestamp)` as any),
    );

  return qb;
}
